export default "__VITE_ASSET__m6Op7GR1__"